/**
 * Created by Jie Gao on 2017-05-17.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite, TweenLite} from "gsap";
import {ISpriteConfig} from "../animation/IAnimationConfig";
import {AnimationHelper} from "../utils/AnimationHelper";

export class WixxForegroundRespinView extends BaseView {

    private readonly WHITE_BAR_POSITIONS:number[] = [353 + 72, 570 + 72, 790 + 72];

    private readonly TEXT_CONFIG:ISpriteConfig[] = [
        {
            texture : "foreground_respin_text_0",
            positionX : 327 + 72,
            animation : [
                {frame : 0, y : 778.5 - 12, alpha : 1},
                {frame : 2, y : 778.5 - 12, alpha : 1},
                {frame : 6, y : 286.5 - 12, alpha : 1},
                {frame : 31, y : 307.5 - 12, alpha : 1},
                {frame : 42, y : 307.5 - 12, alpha : 1},
                {frame : 43, y : 307.5 - 12, alpha : 0.1},
                {frame : 44, y : 307.5 - 12, alpha : 0.7},
                {frame : 46, y : 307.5 - 12, alpha : 0},
                {frame : 47, y : 307.5 - 12, alpha : 1},
                {frame : 51, y : 307.5 - 12, alpha : 0},
                {frame : 53, y : 307.5 - 12, alpha : 1},
                {frame : 54, y : 307.5 - 12, alpha : 0},
                {frame : 55, y : 307.5 - 12, alpha : 1},
                {frame : 56, y : 307.5 - 12, alpha : 0}
            ]
        },
        {
            texture : "foreground_respin_text_1",
            positionX : 460 + 72,
            animation : [
                {frame : 0, y : -109.5 - 12, alpha : 1},
                {frame : 4, y : -109.5 - 12, alpha : 1},
                {frame : 12, y : 310 - 12, alpha : 1},
                {frame : 31, y : 319 - 12, alpha : 1},
                {frame : 44, y : 319 - 12, alpha : 1},
                {frame : 45, y : 319 - 12, alpha : 0.1},
                {frame : 46, y : 319 - 12, alpha : 0.7},
                {frame : 48, y : 319 - 12, alpha : 0},
                {frame : 49, y : 319 - 12, alpha : 1},
                {frame : 53, y : 319 - 12, alpha : 0},
                {frame : 55, y : 319 - 12, alpha : 1},
                {frame : 56, y : 319 - 12, alpha : 0},
                {frame : 57, y : 319 - 12, alpha : 1},
                {frame : 58, y : 319 - 12, alpha : 0}
            ]
        },
        {
            texture : "foreground_respin_text_2",
            positionX : 680 + 72,
            animation : [
                {frame : 0, y : 711.5 - 12, alpha : 1},
                {frame : 5, y : 711.5 - 12, alpha : 1},
                {frame : 10, y : 272.5 - 12, alpha : 1},
                {frame : 25, y : 297.5 - 12, alpha : 1},
                {frame : 41, y : 297.5 - 12, alpha : 1},
                {frame : 42, y : 297.5 - 12, alpha : 0.1},
                {frame : 43, y : 297.5 - 12, alpha : 0.7},
                {frame : 45, y : 297.5 - 12, alpha : 0},
                {frame : 46, y : 297.5 - 12, alpha : 1},
                {frame : 50, y : 297.5 - 12, alpha : 0},
                {frame : 52, y : 297.5 - 12, alpha : 1},
                {frame : 53, y : 297.5 - 12, alpha : 0},
                {frame : 54, y : 297.5 - 12, alpha : 1},
                {frame : 55, y : 297.5 - 12, alpha : 0}
            ]
        },
        {
            texture : "foreground_respin_text_3",
            positionX : 812 + 72,
            animation : [
                {frame : 0, y : -96.5 - 12, alpha : 1},
                {frame : 7, y : -96.5 - 12, alpha : 1},
                {frame : 14, y : 280.5 - 12, alpha : 1},
                {frame : 31, y : 288 - 12, alpha : 1},
                {frame : 38, y : 288 - 12, alpha : 1},
                {frame : 40, y : 288 - 12, alpha : 0.7},
                {frame : 41, y : 288 - 12, alpha : 0.1},
                {frame : 47, y : 288 - 12, alpha : 0},
                {frame : 48, y : 288 - 12, alpha : 1},
                {frame : 52, y : 288 - 12, alpha : 0},
                {frame : 54, y : 288 - 12, alpha : 1},
                {frame : 55, y : 288 - 12, alpha : 0},
                {frame : 56, y : 288 - 12, alpha : 1},
                {frame : 57, y : 288 - 12, alpha : 0}
            ]
        }
    ];

    private readonly FRAME_SPEED:number = 0.0333333333333333;

    private _layer:PIXI.Container;
    private _whiteBarsSprites:TimelineSprite[];
    private _textSprites:PIXI.Sprite[];

    constructor(layer:PIXI.Container) {
        super();
        this._layer = layer;
    }

    protected initAnimations():void {
        if(!this._whiteBarsSprites) {
            this._whiteBarsSprites = [];
            for(let i = 0; i < this.WHITE_BAR_POSITIONS.length; i++) {
                const whiteBar:TimelineSprite = AnimationHelper.createTimelineSprite(GameResources.getTextures("foreground_respin"));
                whiteBar.x = this.WHITE_BAR_POSITIONS[i];
                whiteBar.anchor.set(0.5, 0);
                this._whiteBarsSprites.push(whiteBar);
                this._layer.addChild(whiteBar);
            }
        }
        if(!this._textSprites) {
            this._textSprites = [];
            for(let j = 0; j < this.TEXT_CONFIG.length; j++) {
                if(this.TEXT_CONFIG[j] && this.TEXT_CONFIG[j].texture) {
                    const textSprite:PIXI.Sprite = AnimationHelper.createSprite(this.TEXT_CONFIG[j]);
                    this._textSprites.push(textSprite);
                    this._layer.addChild(textSprite);
                }
            }
        }
    }

    public playAnimation():TimelineLite {
        const timeline = new TimelineLite();
        timeline.add([
            () => {
                this.reset();
            },
            this.getWhiteBarAnimation(this._whiteBarsSprites),
            this.getAllTextAnimation(this._textSprites)
        ]);

        return timeline;
    }

    private getWhiteBarAnimation(whiteBars:TimelineSprite[]):TimelineLite {
        const timeline = new TimelineLite();
        const whiteBarAnimations:TimelineLite[] = [];
        for(let i:number = 0; i < whiteBars.length; i++) {
            if(whiteBars[i]) {
                const tl:TimelineLite = new TimelineLite();
                tl.add(new TweenLite(whiteBars[i]!, 0, {alpha : 1}), 0);
                tl.add(whiteBars[i]!.getAnimation(), 0);
                whiteBarAnimations.push(tl);
            }
        }
        timeline.add(whiteBarAnimations);
        return timeline;
    }

    private getAllTextAnimation(texts:PIXI.Sprite[]):TimelineLite {
        const timeline = new TimelineLite();
        const animations = [];
        for(let i:number = 0; i < texts.length; i++) {
            if(texts[i]) {
                animations.push(this.getSingleTextAnimation(texts[i], i));
            }
        }
        timeline.add(animations);
        return timeline;
    }

    private getSingleTextAnimation(text:PIXI.Sprite, index:number):TimelineLite {
        const timeline = new TimelineLite();
        const fs = this.FRAME_SPEED;
        const config = this.TEXT_CONFIG[index];
        const animations = [];
        if(config && config.animation) {
            for(let i:number = 0; i < config.animation.length; i++) {
                const duration = i > 0 ? (config.animation[i].frame - config.animation[i - 1].frame) * fs : 0;
                const delay = i > 0 ? config.animation[i - 1].frame * fs : 0;
                text.x = config.positionX!;
                animations.push(new TweenLite(text, duration, {
                    y : config.animation[i].y,
                    alpha : config.animation[i].alpha,
                    delay : delay
                }));
            }
        }
        timeline.add(animations);
        return timeline;
    }

    private reset():void {
        if(this._whiteBarsSprites) {
            for(let i:number = 0; i < this._whiteBarsSprites.length; i++) {
                if(this._whiteBarsSprites[i]) {
                    this._whiteBarsSprites[i].alpha = 0;
                }
            }
        }

        if(this._textSprites) {
            for(let j:number = 0; j < this._textSprites.length; j++) {
                if(this._textSprites[j]) {
                    this._textSprites[j].alpha = 0;
                }
            }
        }
    }
}
